export const theme = {
  axis: {
    ticks: {
      text: {
        fontSize: 12,
        fill: '#2E4063',
        fontWeight: 600,
        fontFamily: 'Inter',
      },
    },
  },
  grid: {
    line: {
      strokeWidth: 1,
      stroke: 'rgba(46, 64, 99, 0.5)',
    },
  },
  tooltip: {
    container: {
      width: 300,
      padding: 0,
    },
  },
};
